exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-active {\n  background-color: #d8d8d8;\n}\n\n.container-logo{\n\tmargin-top: 10px;\n\ttext-align: center;\n}\n\nh1 {\n\tmargin-left: auto;\n\tmargin-right: auto;\n\ttext-align: center;\n\tborder-bottom: groove;\n\tborder-color: #9BC65C;\n\tcolor: #7C296F;\n}\n\n.navbar-container {\n  margin: 20px 0 5px 0;\n}\n\n.navbar-container > div > button {\n  cursor: pointer;\n}\n\n\nimg#WallE {\n\tbackground: none;\n    width: 250px;\n    height: 462px;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n\nng-component {\n  z-index:100;\n}\n\n@media screen and (max-width:850px) {\n     img#WallE {\n         width: 120px;\n         height: 222px;\n     }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /www/sms-simulator/sms-front/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = 1